module.exports = __webpack_public_path__ + "media/bootstrap-icons/forward-fill-09e19cde.svg";